module.exports = "<div class=\"spinner-loading-wrapper\"> <p class=\"m-t-sm text-error\"> Error loading citations. Please try refreshing the page.   </p> </div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./website/static/citations_load_error.html
// module id = 424
// module chunks = 37 39